/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DepartmentSpeciality from './department-speciality';
import DepartmentSpecialityDetail from './department-speciality-detail';
import DepartmentSpecialityUpdate from './department-speciality-update';
import DepartmentSpecialityDeleteDialog from './department-speciality-delete-dialog';

const DepartmentSpecialityRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DepartmentSpeciality />} />
    <Route path="new" element={<DepartmentSpecialityUpdate />} />
    <Route path=":id">
      <Route index element={<DepartmentSpecialityDetail />} />
      <Route path="edit" element={<DepartmentSpecialityUpdate />} />
      <Route path="delete" element={<DepartmentSpecialityDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DepartmentSpecialityRoutes;
